import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { methodList } from './../methodManage/request';
import { paymentDownload } from '../oldListManage/request';
import infoModel from './infoModel.vue';
import { downloadFileFun } from '@/utils/public';
import { customerResource } from '@/views/system/customerManage/request';
import { applicationResource } from '@/views/customer/applicationManage/request';
import { payInfoList } from '../request1';
export default {
  components: {
    infoModel
  },
  data() {
    return {
      infoShow: false,
      form: {
        infoType: 'PAY'
      },
      typeList: [],
      customerList: [],
      applicationList: [],
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '交易流水号'
        },
        dataIndex: 'payNo',
        key: 'payNo',
        align: 'center',
        customRender: text => {
          return {
            children: text || '—'
          };
        }
      }, {
        slots: {
          title: '投保流水号'
        },
        dataIndex: 'searchNo',
        key: 'searchNo',
        align: 'center',
        customRender: text => {
          return {
            children: text || '—'
          };
        }
      }, {
        slots: {
          title: '支付方式'
        },
        dataIndex: 'payType',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'payType'
        }
      }, {
        slots: {
          title: '订单金额'
        },
        dataIndex: 'orderAmount',
        key: 'orderAmount',
        align: 'center'
      }, {
        slots: {
          title: '应用名称'
        },
        dataIndex: 'applicationName',
        key: 'applicationName',
        align: 'center',
        customRender: text => {
          return {
            children: text || '—'
          };
        }
      }, {
        slots: {
          title: '交易状态'
        },
        dataIndex: 'statusName',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'statusName'
        }
      }, {
        slots: {
          title: '操作'
        },
        key: '8',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 180
      }]
    };
  },
  async created() {
    methodList().then(res => {
      this.typeList = res.items;
    });
    if (this.$store.state.user.accountInfo.tag) {
      await this.getCustomerList();
    } else {
      this.form.customerId = this.$store.state.user.accountInfo.customerId;
    }
    await this.customerChange();
    this.searchFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = this.form;
      obj.pageSize = this.pagination.pageSize;
      obj.page = this.pagination.current;
      payInfoList(obj).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleSee(val) {
      this.infoShow = true;
      this.$nextTick(() => {
        this.$refs.infoFrom.init(val);
      });
    },
    async getCustomerList() {
      this.customerList = await customerResource({});
      let arr = this.customerList.find(item => item.id == Number(sessionStorage.getItem('insuredHomePayId')));
      this.form.customerId = arr ? Number(sessionStorage.getItem('insuredHomePayId')) : this.customerList[0].id;
      sessionStorage.setItem('insuredHomePayId', this.form.customerId);
    },
    async customerChange() {
      this.$set(this.form, 'applicationId', undefined);
      // this.form.applicationId = undefined;
      if (this.form.customerId) {
        this.applicationList = await applicationResource({
          customerId: this.form.customerId
        });
        sessionStorage.setItem('insuredHomePayId', this.form.customerId);
      } else {
        this.applicationList = [];
      }
    },
    downloadFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      paymentDownload(obj).then(res => {
        console.log(res);
        let nowDate = new Date();
        let time = nowDate.getFullYear() + '-' + Number(Number(nowDate.getMonth()) + 1) + '-' + nowDate.getDate();
        downloadFileFun(res, 'application/vnd.ms-excel', this.$t('支付列表') + time + '.xlsx');
      });
    },
    reset() {
      this.form = {
        infoType: 'PAY'
      };
    }
  }
};